"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseService = void 0;
const operators_1 = require("rxjs/operators");
const createLunaError_1 = require("./utils/createLunaError");
const sessionRevokedException = 'com.unitedtraders.luna.platform2.security.server.exception.SessionRevokedException';
const cancelSubscriptionOnLogoutException = 'com.unitedtraders.luna.platform2.web.exceptions.CancelSubscriptionOnLogoutException';
class BaseService {
    constructor(clients, logger, schema, options) {
        this.clientName = 'BaseService';
        this.logger = logger;
        this.clients = clients;
        if (options.config) {
            const actualOptions = options;
            this.config = actualOptions.config;
            this.removeTokens = actualOptions.removeTokens;
        }
        else {
            const config = options;
            this.config = config;
        }
    }
    createRest(name, isAuthorized, requestSchema, responseSchema, fancyName) {
        return (request, metadata, options) => {
            const client = isAuthorized ? this.clients.securedRest : this.clients.rest;
            this.logger.debug(`${fancyName}: Request:`, request);
            const response = client.send(name, request, metadata);
            return response
                .then(data => {
                this.logger.debug(`${fancyName}: Response:`, data.data);
                return data;
            })
                .catch(error => {
                var _a, _b, _c, _d;
                const responseBody = typeof ((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === 'object'
                    ? JSON.stringify((_b = error.response) === null || _b === void 0 ? void 0 : _b.data)
                    : (_c = error.response) === null || _c === void 0 ? void 0 : _c.data;
                const requestBody = typeof request === 'object' ? JSON.stringify(request) : request;
                const msg = `${fancyName}: Error in request to url=${name}, response status=${(_d = error.response) === null || _d === void 0 ? void 0 : _d.status}, ` +
                    `response body=${responseBody}, ` +
                    `request=${requestBody}, error message=${error.message}`;
                this.logger.debug(msg);
                if (options === null || options === void 0 ? void 0 : options.transformError) {
                    throw (0, createLunaError_1.createLunaError)(error);
                }
                throw error;
            });
        };
    }
    createStream(name, isAuthorized, requestSchema, responseSchema, fancyName) {
        return (request, metadata, options) => {
            this.logger.debug(`${fancyName}: Subscribe:`, request);
            return this.clients
                .stream.topic({
                parameters: request,
                name,
                metadata,
                isAuthorized,
                isRaw: options && options.isRaw
            })
                .pipe((0, operators_1.tap)(data => {
                this.logger.debug(`${fancyName}: Response:`, data);
            }), (0, operators_1.catchError)((error) => {
                var _a;
                if (error.type === sessionRevokedException ||
                    error.type === cancelSubscriptionOnLogoutException) {
                    (_a = this.removeTokens) === null || _a === void 0 ? void 0 : _a.call(this);
                }
                throw error;
            }));
        };
    }
}
exports.BaseService = BaseService;
//# sourceMappingURL=BaseService.js.map